(function () {
  function init(root) {
    if (root.dataset.ppfReady) return;
    root.dataset.ppfReady = '1';

    var cfgEl = root.querySelector('[data-ppf-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }

    var toastEl = root.querySelector('[data-ppf-toast]');
    var toastMsg = root.querySelector('[data-ppf-toast-msg]');
    var toastTimer = null;

    function toast(msg) {
      if (!toastEl || !msg) return;
      if (toastMsg) toastMsg.textContent = msg;
      toastEl.classList.add('is-visible');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3400);
    }

    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var fmt = cfg.moneyFormat || '${{amount}}';
    var qty = 1;
    var bundle = false;

    function money(cents) {
      var amount = cents / 100;
      var withCents = amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      var noCents = Math.round(amount).toString().replace(/\d(?=(\d{3})+$)/g, '$&,');
      return fmt
        .replace('{{amount}}', withCents)
        .replace('{{amount_with_comma_separator}}', withCents.replace('.', ','))
        .replace('{{amount_no_decimals}}', noCents)
        .replace('{{amount_no_decimals_with_comma_separator}}', noCents);
    }

    function lineTotal() {
      var base = (cfg.price || 0) * qty;
      if (bundle && cfg.partnerId) base += (cfg.partnerPrice || 0) * qty;
      return base;
    }

    function paint() {
      root.querySelectorAll('[data-ppf-qty-val]').forEach(function (el) { el.textContent = qty; });
      root.querySelectorAll('[data-ppf-line]').forEach(function (el) { el.textContent = money(lineTotal()); });
    }

    root.querySelectorAll('[data-ppf-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-ppf-qty'), 10) || 0;
        qty = Math.max(1, Math.min(99, qty + step));
        paint();
      });
    });

    var addon = root.querySelector('[data-ppf-addon]');
    if (addon) {
      addon.addEventListener('click', function () {
        bundle = !bundle;
        addon.classList.toggle('is-on', bundle);
        addon.setAttribute('aria-pressed', bundle ? 'true' : 'false');
        paint();
      });
    }

    function afterAdd() {
      fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true, detail: { baseEvent: 'ppf:add', cart: cart }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer, .cart-drawer');
          if (drawer && typeof drawer.show === 'function') drawer.show();
          else if (drawer && typeof drawer.open === 'function') drawer.open();
          else document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        })
        .catch(function () {});
    }

    function post(items, btns) {
      if (btns) btns.forEach(function (b) { b.disabled = true; });
      return fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (res) { if (!r.ok) throw res; return res; }); })
        .then(function () {
          afterAdd();
          if (btns) {
            btns.forEach(function (b) {
              var lbl = b.querySelector('[data-ppf-atc-label]');
              if (!lbl) return;
              if (b.dataset.ppfLabel === undefined) b.dataset.ppfLabel = lbl.textContent;
              lbl.textContent = cfg.addedLabel || 'Added';
            });
            setTimeout(function () {
              btns.forEach(function (b) {
                var lbl = b.querySelector('[data-ppf-atc-label]');
                if (lbl && b.dataset.ppfLabel) lbl.textContent = b.dataset.ppfLabel;
              });
            }, 2200);
          }
        })
        .catch(function (err) {
          toast((err && (err.description || err.message)) || cfg.cartErrorLabel || 'Sorry, that could not be added to your cart.');
        })
        .then(function () { if (btns) btns.forEach(function (b) { b.disabled = false; }); });
    }

    var atcBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ppf-atc]'));
    atcBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!cfg.variantId || cfg.available === false) return;
        var items = [{ id: cfg.variantId, quantity: qty }];
        if (bundle && cfg.partnerId && cfg.partnerAvailable) items.push({ id: cfg.partnerId, quantity: qty });
        post(items, atcBtns);
      });
    });

    root.querySelectorAll('[data-ppf-add-one]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = parseInt(btn.getAttribute('data-ppf-add-one'), 10);
        if (!id) return;
        post([{ id: id, quantity: 1 }], [btn]);
      });
    });

    var sticky = root.querySelector('[data-ppf-sticky]');
    if (sticky) {
      var footerVisible = false;
      var onScroll = function () {
        var past = (window.scrollY || window.pageYOffset || 0) > 600;
        if (past && !footerVisible) sticky.classList.add('is-visible');
        else sticky.classList.remove('is-visible');
      };
      var footer = document.querySelector('.shopify-section--footer, footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          onScroll();
        }, { rootMargin: '0px 0px 80px 0px' }).observe(footer);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-ppf]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
